import { Zap } from "lucide-react";
import React from "react";
import { checkDecimal, cn } from "src/helpers";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "src/shadcn/components/ui";

type Props = {
  BILL_COMPARIZON_DATA: any;
};

const SampleBillComparison = ({ BILL_COMPARIZON_DATA }: Props) => {
  return (
    <div className="">
      <div className="max-sm:w-[80vw] max-sm:overflow-auto">
        <Table>
          <TableHeader className="bg-slate-200">
            <TableRow>
              <TableHead className="font-semibold sticky left-0 bg-slate-200">Component</TableHead>
              <TableHead className="font-semibold text-center">Old Tariff (₹)</TableHead>
              <TableHead className="font-semibold text-center">New Tariff (₹)</TableHead>
              <TableHead className="font-semibold text-center">Change (₹)</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {BILL_COMPARIZON_DATA?.tabledata.map((row: any, index: number) => (
              <TableRow key={index} className={index % 2 === 0 ? "bg-muted/50" : ""}>
                <TableCell
                  className={cn("font-medium  sticky left-0 ", {
                    "bg-muted": index % 2 === 0,
                    "bg-white": index % 2 !== 0,
                  })}
                >
                  {row.isRebate && (
                    <div className="flex items-center gap-1">
                      <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
                      {row.component}
                    </div>
                  )}
                  {!row.isRebate && row.component}
                </TableCell>
                <TableCell className="text-center">{row.oldTariff}</TableCell>
                <TableCell className="text-center">{row.newTariff}</TableCell>
                <TableCell className="text-center  font-medium">
                  {row.change?.startsWith("-") ? (
                    <span className="text-green-600 ">{row.change ? `${row.change}` : "-"} </span>
                  ) : row.change?.startsWith("+") ? (
                    <span className="text-red-600">{row.change ? `${row.change}` : "-"}</span>
                  ) : (
                    row.change && <span className="text-gray-600">{row.change ? `${row.change}` : "-"}</span>
                  )}
                </TableCell>
              </TableRow>
            ))}
            <TableRow className="border-t-2 border-gray-300 bg-gray-100">
              <TableCell className="font-bold text-lg  sticky left-0 bg-gray-100 ">Total</TableCell>
              <TableCell className="text-center font-bold">
                {BILL_COMPARIZON_DATA?.total?.oldTariff
                  ? checkDecimal(BILL_COMPARIZON_DATA?.total?.oldTariff, true)
                  : "-"}
              </TableCell>
              <TableCell className="text-center font-bold">
                {BILL_COMPARIZON_DATA?.total?.newTariff
                  ? checkDecimal(BILL_COMPARIZON_DATA?.total?.newTariff, true)
                  : "-"}
              </TableCell>
              {/* <TableCell className="text-center font-medium">
                                    {row.oldTariff > row?.newTariff ? (
                                        <span className="text-red-600">-{row.change}</span>
                                    ) : row.change === '0' ? (
                                        <span className="text-gray-600">{row.change}</span>
                                    ) : (
                                        <span className="text-green-600">+{row.change}</span>
                                    )}
                                </TableCell> */}
              {/* <TableCell className="text-center font-bold text-red-600">{BILL_COMPARIZON_DATA?.total?.change ? BILL_COMPARIZON_DATA?.total?.change : 0}</TableCell> */}
              <TableCell className="text-center font-medium">
                {BILL_COMPARIZON_DATA?.total?.change && BILL_COMPARIZON_DATA?.total?.change?.startsWith("-") ? (
                  <span className="text-green-600">
                    {BILL_COMPARIZON_DATA?.total?.change ? `${BILL_COMPARIZON_DATA?.total?.change}` : "-"}{" "}
                  </span>
                ) : BILL_COMPARIZON_DATA?.total?.change?.startsWith("+") ? (
                  <span className="text-red-600">
                    {BILL_COMPARIZON_DATA?.total?.change ? `${BILL_COMPARIZON_DATA?.total?.change}` : "-"}
                  </span>
                ) : (
                  <span className="text-gray-600">
                    {BILL_COMPARIZON_DATA?.total?.change ? `${BILL_COMPARIZON_DATA?.total?.change}` : "-"}
                  </span>
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>

      {BILL_COMPARIZON_DATA?.total?.percentageIncrease ? (
        <div className="mt-4 p-4 bg-orange-50 border border-orange-200 rounded-lg">
          <p className="text-sm text-orange-800 font-medium">
            <strong>Overall bill impact:</strong> Total increase of approximately{" "}
            <>{BILL_COMPARIZON_DATA?.total?.percentageIncrease}</> in monthly HT bills due to MYT changes.
          </p>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default SampleBillComparison;
